import { ICourseEnrollmentItem } from '../components/SelectAdditionalCourses/components/SelectCourseCard/SelectCourseCard'

export const getTariffPrice = (
  tariff?: ICourseTariff,
  value?: number,
): number => {
  if (!tariff || !value) return 0
  try {
    if (['minute', 'hour', 'month']?.includes(tariff?.type)) {
      return Number(tariff?.first_price) * value
    }
    if ('stream_custom_period' === tariff?.type) {
      return (
        tariff?.tariffPeriods?.find((item) => item.months === value)?.price ??
        Number(tariff?.first_price)
      )
    }
    if ('stream_custom_days' === tariff?.type) {
      return (
        tariff?.tariffDays?.find((item) => item.days === value)?.price ??
        Number(tariff?.first_price)
      )
    }
    return Number(tariff?.first_price)
  } catch (error) {
    return Number(tariff?.first_price)
  }
}

export const getPromoCodeDiscountString = (
  discount?: IPromoCodeDiscount | null,
): string => {
  if (!discount) return ''
  switch (discount?.type) {
    case 'percent':
      return `- ${Number(discount.discount)}%`
    case 'sum':
      return `- ${Number(discount.discount)}р`
  }
  return 'с промокодом'
}

export const getPriceWithDiscount = (
  price: number,
  discount?: IPromoCodeDiscount | null,
): number => {
  try {
    let priceWithDiscount = price
    if (discount) {
      switch (discount?.type) {
        case 'percent':
          priceWithDiscount = price - (price * Number(discount.discount)) / 100
          break
        case 'sum':
          priceWithDiscount = price - Number(discount.discount)
          break

        default:
          priceWithDiscount = price
      }
    } else {
      priceWithDiscount = price
    }
    return Number((priceWithDiscount < 0 ? 0 : priceWithDiscount).toFixed(2))
  } catch (error) {
    return price
  }
}

export const getTariffPriceWithDiscount = (
  tariff?: ICourseTariff,
  value?: number,
  discount?: IPromoCodeDiscount | null,
): number => {
  if (!tariff || !value || tariff?.type === 'free') return 0
  try {
    const currentPrice = getTariffPrice(tariff, value)
    let price = getTariffPrice(tariff, value)
    if (discount) {
      switch (discount?.type) {
        case 'percent':
          price =
            currentPrice - (currentPrice * Number(discount.discount)) / 100
          break
        case 'sum':
          price = currentPrice - Number(discount.discount)
          break

        default:
          price = currentPrice
      }
    } else {
      price = currentPrice
    }
    return Number((price < 0 ? 0 : price).toFixed(2))
  } catch (error) {
    return getTariffPrice(tariff, value)
  }
}

export const getTariffOldPrice = (
  tariff?: ICourseTariff,
  value?: number,
): string => {
  if (!tariff || !value) return ''
  try {
    if ('stream_custom_period' === tariff?.type) {
      const oldPrice = tariff?.tariffPeriods?.find(
        (item) => item?.months === value,
      )?.old_price

      if (oldPrice && !isNaN(Number(oldPrice))) {
        return oldPrice?.toString()
      }
    }

    if ('stream_custom_days' === tariff?.type) {
      const oldPrice = tariff?.tariffDays?.find(
        (item) => item?.days === value,
      )?.old_price

      if (oldPrice && !isNaN(Number(oldPrice))) {
        return oldPrice?.toString()
      }
    }

    if (tariff?.old_price === null || tariff?.old_price === '') return ''

    let oldPrice = Number(tariff?.old_price)

    if (['minute', 'hour', 'month']?.includes(tariff?.type)) {
      oldPrice = oldPrice * value
    }

    return Number(oldPrice.toFixed(2))?.toString()
  } catch (error) {
    return ''
  }
}

export const getTotalPrice = (
  tariff?: ICourseTariff,
  value?: number,
  discount?: IPromoCodeDiscount | null,
  withDemo?: boolean,
  extraCourses?: ICourseEnrollmentItem[],
  extraCoursesDiscount?: number[],
  extraCoursesDiscountUnit?: string,
): number => {
  try {
    const firstFree = tariff?.type === 'free' || (withDemo ?? false)
    let coursePrice = withDemo
      ? 0
      : getTariffPriceWithDiscount(tariff, value, discount)
    extraCourses?.forEach((order, index) => {
      if (!order?.withDemo) {
        coursePrice += getTariffPriceWithDiscount(
          order?.course?.directionTariffs?.find(
            (tariff) => tariff?.id === order.tariffId,
          ),
          order?.value ?? undefined,
          getDiscount(
            firstFree,
            index,
            extraCourses,
            extraCoursesDiscount ?? [],
            extraCoursesDiscountUnit ?? '',
          ),
        )
      }
    })

    return Number(coursePrice.toFixed(2))
  } catch (error) {
    return 0
  }
}

export const getDiscount = (
  isFirstFree: boolean,
  index: number,
  courses: ICourseEnrollmentItem[],
  discounts: number[],
  discountsUnit: string,
): IPromoCodeDiscount | null => {
  try {
    let paidCount = isFirstFree ? -1 : 0

    for (let i = 0; i < index; i++) {
      if (
        courses[i]?.withDemo ||
        courses[i]?.course?.directionTariffs?.find(
          (item) => item?.id === courses[i]?.tariffId,
        )?.type === 'free'
      ) {
        continue
      }
      paidCount++
    }

    if (paidCount < 0) return null

    return {
      type: discountsUnit === 'percent' ? 'percent' : 'sum',
      discount: discounts?.[paidCount] ?? 0,
    } as IPromoCodeDiscount
  } catch (error) {
    return null
  }
}

export const checkIsAllCoursesFree = (courses: ICourseEnrollmentItem[]): boolean => {
  return courses.every(
    (order) =>
      order.withDemo ||
      order.course?.directionTariffs?.find(
        (tariff) => tariff.id === order.tariffId,
      )?.type === 'free',
  )
}
